var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHierarchyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1443 17.3743V7.70572C13.1443 6.37077 14.2265 5.28857 15.5614 5.28857H26.4386C27.7735 5.28857 28.8557 6.37077 28.8557 7.70572V17.3743C28.8557 18.7092 27.7735 19.7914 26.4386 19.7914H15.5614C14.2265 19.7914 13.1443 18.7092 13.1443 17.3743Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.7914V29.46",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91431 29.46V27.0429C8.91431 25.7079 9.99651 24.6257 11.3314 24.6257H30.6686C32.0036 24.6257 33.0857 25.7079 33.0857 27.0429V29.46",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28857 34.2943V31.8771C5.28857 30.5421 6.37077 29.46 7.70572 29.46H10.1229C11.4578 29.46 12.54 30.5421 12.54 31.8771V34.2943C12.54 35.6293 11.4578 36.7114 10.1229 36.7114H7.70572C6.37077 36.7114 5.28857 35.6293 5.28857 34.2943Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3743 34.2943V31.8771C17.3743 30.5421 18.4565 29.46 19.7914 29.46H22.2086C23.5435 29.46 24.6257 30.5421 24.6257 31.8771V34.2943C24.6257 35.6293 23.5435 36.7114 22.2086 36.7114H19.7914C18.4565 36.7114 17.3743 35.6293 17.3743 34.2943Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46 34.2943V31.8771C29.46 30.5421 30.5421 29.46 31.8771 29.46H34.2942C35.6292 29.46 36.7114 30.5421 36.7114 31.8771V34.2943C36.7114 35.6293 35.6292 36.7114 34.2942 36.7114H31.8771C30.5421 36.7114 29.46 35.6293 29.46 34.2943Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHierarchyOutline);
export default __webpack_public_path__ + "static/media/icon_hierarchy_outline.86e38cfb3a51be2ff3b8ea7910f49575.svg";
export { ForwardRef as ReactComponent };